<script lang="ts">
  import { useNavigate } from 'svelte-navigator'
  import Dropdown from 'sv-bootstrap-dropdown'

  export let selected

  let dropdownTrigger
  let dropdownIsOpen
  let dropdownArrowSrc

  const navigate = useNavigate()
</script>

<div class="secondary-dropdown">
  <Dropdown
    triggerElement={dropdownTrigger}
    onOpened={() => {
      dropdownIsOpen = true
    }}
    onClosed={() => {
      dropdownIsOpen = false
    }}
  >
    <button class="dropdown-current-label" type="button" bind:this={dropdownTrigger}>
      {dropdownIsOpen ? 'Sezioni' : selected}
      <img
        src={dropdownIsOpen ? 'img/dropdown-arrow-open.svg' : 'img/dropdown-arrow-closed.svg'}
        alt="dropdown arrow control"
      />
    </button>
    <div slot="DropdownMenu" class="dropdown-items">
      {#each ['Profilazione', 'Durata dello spostamento', 'Mezzo di trasporto', "Motivi d'uso auto", 'Propensione al cambiamento'] as item}
        <button
          class="dropdown-item {selected === item ? 'dropdown-current-label' : ''}"
          type="button"
          on:click={() => {
            selected = item
          }}
        >
          {item}
        </button>
      {/each}
    </div>
  </Dropdown>
</div>

<style>
  @import url('https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css');

  :global(.secondary-dropdown .dropdown) {
    position: fixed;
    top: 55px;
    left: 0;
    z-index: 2;
  }
  :global(.secondary-dropdown .dropdown-menu) {
    background-color: #1e1e1e;
    transform: translateY(55px) !important;
  }

  .dropdown-items {
    display: flex;
    flex-direction: column;
  }

  .dropdown-current-label,
  .dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100vw;
    margin: 0;
    background: #1e1e1e;
    border: none;
    border-radius: 0;
    text-align: left;
  }

  .dropdown-current-label {
    height: 55px;
    font-size: 16px;
    font-weight: 600;
    padding: 0.4rem 2rem;
    color: white !important;
  }

  .dropdown-item {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.5);
    padding: 1.5rem 2rem;
  }

  button:not(:disabled):active {
    background-color: #1e1e1e;
  }

  button:hover {
    cursor: pointer;
  }
</style>
